import { render, staticRenderFns } from "./Pregunta.vue?vue&type=template&id=7270b3ff&"
import script from "./Pregunta.vue?vue&type=script&lang=js&"
export * from "./Pregunta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports